'use client'

import { HeaderDesktopNavigationSubmenus } from '@/src/domains/header/components/Header/HeaderDesktopNavigation/HeaderDesktopNavigationSubmenus'
import { useHeaderTherapistsSubmenus } from '@/src/domains/header/components/Header/hooks/useHeaderTherapistsSubmenus'

export const HeaderDesktopNavigationTherapists = () => {
  const menus = useHeaderTherapistsSubmenus()

  return <HeaderDesktopNavigationSubmenus menus={menus} />
}
